module.exports = __webpack_public_path__ + "img/delete.b84fc422.svg";